import axios from "axios";
export const appId = "wx494de8ffc8cd5532";

// 全局标记wx.config是否初始化完成
let wxConfigReadyPromise = null;

// 封装签名，返回Promise，外部统一等待
async function getSignature() {
  // 如果已经在请求/配置完成，直接复用Promise，防止重复请求
  if (wxConfigReadyPromise) return wxConfigReadyPromise;

  wxConfigReadyPromise = new Promise(async (resolve, reject) => {
    let url = "https://pmc.youxuepai.com/push/cross/winxin/openjssign.json";
    const currentUrl = location.href.split('#')[0];
    const callbackName = `json${new Date().getTime()}`;
    try {
      const res = await axios.get(`${url}?jsoncallback=${callbackName}&url=${encodeURIComponent(currentUrl)}`);
      let data = res.data;

      // 剥离jsonp包裹
      if (typeof data === "string" && data.startsWith("json")) {
        data = data.replace(new RegExp(`^${callbackName}\\(|\\)$`, "g"), "");
        data = JSON.parse(data);
      }

      if (data.msgCode === 310 && data.data) {
        const appData = data.data;
        wx.config({
          debug: false,
          appId: appData.appid,
          timestamp: appData.timestamp,
          nonceStr: appData.nonceStr,
          signature: appData.signature,
          jsApiList: ["getLocation"],
        });

        // wx.config有自带ready回调，配置真正生效后resolve
        wx.ready(() => {
          resolve(true);
        });
        // 配置失败捕获
        wx.error((err) => {
          reject(`wx配置失败: ${JSON.stringify(err)}`);
          wxConfigReadyPromise = null;
        });
      } else {
        reject(`签名接口返回异常，msgCode:${data.msgCode}`);
        wxConfigReadyPromise = null;
      }
    } catch (err) {
      console.error("获取签名接口异常", err);
      reject(err);
      wxConfigReadyPromise = null;
    }
  });

  return wxConfigReadyPromise;
}

// 获取位置：前置等待wx配置就绪
export async function getLocation() {
  // 关键：先等wx.config加载就绪
  await getSignature();

  return new Promise((resolve, reject) => {
    wx.getLocation({
      type: "wgs84",
      success: function (res) {
        resolve(res);
      },
      cancel: () => {
        reject({ errMsg: "用户拒绝授权获取位置" });
      },
      fail: function (res) {
        console.log("wx.getLocation fail", res);
        reject({ errMsg: "获取位置信息失败" });
      },
    });
  });
}

// 跳转微信授权登录
export const goWxAuth = () => {
  const redirectUri = encodeURIComponent(window.location.href);
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  window.location.href = authUrl;
};

// 页面初始化仅预加载签名（不阻塞页面，后续调用接口自动等待）
getSignature().catch(e => console.log("初始化wx签名预加载失败", e));